import { gridPaths } from '../../../shared/hooks/queryKeys';

const WIPE_DATA_QUERY_ROOTS = new Set([
  'projects',
  'features',
  'releases',
  'suites',
  'suiteRuns',
  'tests',
  'testRuns',
  'builds',
  'jobs',
  'pipelines',
  'stages',
  'stage-runs',
  'uploads',
  'results-files',
  'execution-runs',
  'executionRuns',
  'coverage-runs',
  'coverage-files',
  'code-directories',
  'code-files',
  'metrics',
]);

const WIPE_DATA_GRID_PATHS: ReadonlySet<string> = new Set([
  gridPaths.projects,
  gridPaths.features,
  gridPaths.releases,
  gridPaths.releasesRelated,
  gridPaths.suites,
  gridPaths.suiteRuns,
  gridPaths.tests,
  gridPaths.testRuns,
  gridPaths.pipelines,
  gridPaths.jobs,
  gridPaths.builds,
  'jobs/page',
  gridPaths.jobRuns,
  'stages/page',
  'pipeline-executions/summary',
  'stages/query',
  'stage-runs/query',
  'pipelines-daily-history',
  gridPaths.uploads,
  gridPaths.coverageRuns,
  gridPaths.coverageFiles,
  gridPaths.resultsFiles,
  gridPaths.executionRuns,
  'coverage-runs/local-table',
  'coverage-files/local-table',
  'coverage-code-files/local-table',
]);

export const isWipeDataQueryKey = (queryKey: readonly unknown[]): boolean => {
  const root = queryKey[2];
  if (typeof root !== 'string') return false;
  if (WIPE_DATA_QUERY_ROOTS.has(root)) return true;
  if (root !== 'datagrid') return false;
  const path = queryKey[3];
  return typeof path === 'string' && WIPE_DATA_GRID_PATHS.has(path);
};
